import { useQuery } from '@tanstack/react-query';
import { getFetch } from '@legacy/utils/fetcher';
import { parseMenu } from '@legacy/utils/menu';
import { useTranslation } from 'react-i18next';
import {
  IMenus,
  IMenusPropertiesWithPagePath,
} from '@legacy/apis/types/menusAPI';

const CREATE_MENU_URL_PATH = '/api/v2/menus/create';
export const CREATE_MENU_MSW_STATUS_KEY = 'createMenuAPI';

export const CREATE_MENU_KEY = 'CREATE_MENU';

const getCreateMenu = (): Promise<IMenus> =>
  getFetch({ path: CREATE_MENU_URL_PATH, key: CREATE_MENU_MSW_STATUS_KEY });

export const useCreateMenu = () => {
  const { data, ...restProps } = useQuery({
    queryKey: [CREATE_MENU_KEY],
    queryFn: getCreateMenu,
  });
  const { t } = useTranslation('quickCreateNavigation');
  const quickCreateMenu: IMenusPropertiesWithPagePath[] = parseMenu(data, t);
  return {
    quickCreateMenu,
    isQuickCreateMenuEmpty: quickCreateMenu.length <= 0,
    ...restProps,
  };
};
